import React from "react";
import PropTypes from "prop-types";
import filterTypes from "data/filter-types";

const SelectFilter = ({
                        name,
                        onChange,
                        filters,
                        defaultValue,
                        defaultFilterType
                      }) => {
  if (filters.length <= 1) return null;

  return (
    <select
      className="form-control form-control-sm w-25"
      name={name}
      onChange={(ev) => onChange(ev, defaultValue)}
      defaultValue={defaultFilterType || filters[0] || filterTypes.EQUALS.value}
    >
      {filters.map(filterKeyword => (
        <option
          key={filterKeyword}
          value={filterKeyword}
        >
          {filterTypes[filterKeyword].title}
        </option>
      ))}
    </select>
  );
};

SelectFilter.defaultProps = {
  defaultValue: "",
  filters: []
};

SelectFilter.propTypes = {
  name: PropTypes.string.isRequired,
  filters: PropTypes.array.isRequired,
  defaultValue: PropTypes.any.isRequired,
  defaultFilterType: PropTypes.any.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default SelectFilter;



// WEBPACK FOOTER //
// ./src/views/lib/components/filter/select-filter.js